import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    console.log("DV360 Advertiser Loader connected", this.urlValue)
  }

  loadAdvertisers(event) {
    // Get the URL from the radio button's data attribute
    const url = event.target.dataset.turboUrl
    
    console.log("Loading advertisers from URL:", url)
    
    if (!url) {
      console.error("Missing turbo URL in radio button data attribute")
      return
    }

    console.log("Fetching from:", url)

    // Fetch DV360 advertiser accounts via Turbo Stream
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => {
        console.log("Response received:", response.status)
        return response.text()
      })
      .then((html) => {
        console.log("HTML received:", html.substring(0, 100))
        Turbo.renderStreamMessage(html)
      })
      .catch((error) => {
        console.error("Failed to load DV360 advertisers:", error)
      })
  }
}

